<template>
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <div class="votelist" v-for="item in askList" :key="item.id">
      <router-link :to="{
                path: '/forum/detail',
                query: {
                  id: item.id,
                  cate_id: item.cate_id,
                  title: '线上论坛',
                },
              }">
        <div class="votelist-up">
          <div class="votelist-up-left">
            <p>提问者:{{ item.nickname }}</p>
            <p>{{ item.add_time }}</p>
          </div>

        </div>
        <p class="votelist-desc ellipsis">
          讨论内容：{{ item.title }}
        </p>
        <p class="votelist-desc ellipsis2">
          官方回复：{{ item.answer }}
        </p>
      </router-link>
      <div class="votelist-up-right">
              <p @click.stop="deleteForum(item)">删除讨论</p>
          </div>
    </div>
  </van-list>
</template>
<script setup>
import { ref } from "vue";
import ajax from "@/utils/request.js";
import { showToast } from "vant";

const askList = ref([]);

const page = ref(1);
const loading = ref(false);
const finished = ref(false);

const deleteForum = (item) => {
  ajax.post("users/deleteforumdiscuss",{'id':item.id}).then(res=>{
    if(res.errcode == 1){
      askList.value = []
      getAskList()
    }else{
      showToast({
        message:res.message
      })
    }
  })
}

function getAskList() {
  loading.value = true;
  const data = {
    typeid: 3,
    page: page.value,
  };
  return ajax.post("users/getforumlist", data).then((res) => {
    if (res.data.length < 10) {
      askList.value = askList.value.concat(res.data);
      finished.value = true;
    } else {
      askList.value = askList.value.concat(res.data);
      page.value++;
    }
    console.log(askList.value);
  }).catch(()=>{
    finished.value = true;
  });
}
getAskList().finally(() => {
  loading.value = false;
});

const onLoad = () => {
  getAskList().finally(() => {
    loading.value = false;
  });
};
</script>
  <style scoped>
.votelist {
  padding: 4.2667vw 4vw;
  margin-bottom: 2.6667vw;
  background-color: #fff;
  position: relative;
}
.votelist-up {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}
.votelist-up-left p:first-child {
  font-size: 14px;
  color: #666666;
}
.votelist-up-left p:last-child {
  font-size: 12px;
  color: #999999;
  margin-top: 1.6vw;
}
.votelist-up-right p:first-child {
  font-size: 14px;
  color: #3f7c93;
  padding: 2.1333vw 4.2667vw;
  background-color: #f6f6f6;
  border-radius: 4.2667vw;
}
.votelist-desc {
  margin-top: 1.3333vw;
  color: #333333;
  font-size: 14px;
}
.votelist-up-right {
  position: absolute;
  top: 4.2667vw;
  right: 4vw;
}
</style>